/**
 * VYRO variants — auto-cycling spotlight animation.
 * Bounces highlight from first variant to last, then back, until user
 * touches/clicks anywhere in the section.
 *
 * Markup:
 *   <ol data-vyro-cycle data-vyro-cycle-interval="2400">
 *     <li data-vyro-cycle-item>...</li>
 *     <li data-vyro-cycle-item>...</li>
 *   </ol>
 */
(() => {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED) return;

  const init = (root = document) => {
    root.querySelectorAll('[data-vyro-cycle]').forEach((cycle) => {
      if (cycle.dataset.vyroCycleInit === '1') return;
      cycle.dataset.vyroCycleInit = '1';

      const items = cycle.querySelectorAll('[data-vyro-cycle-item]');
      if (items.length < 2) return;

      const interval = parseInt(cycle.dataset.vyroCycleInterval, 10) || 2400;
      let index = 0;
      let direction = 1;
      let timer = null;
      let stopped = false;

      const setActive = () => {
        items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      };

      const clearActive = () => {
        items.forEach((item) => item.classList.remove('is-active'));
      };

      const advance = () => {
        if (stopped) return;
        index += direction;
        if (index >= items.length - 1) {
          index = items.length - 1;
          direction = -1;
        } else if (index <= 0) {
          index = 0;
          direction = 1;
        }
        setActive();
        timer = setTimeout(advance, interval);
      };

      const stop = () => {
        if (stopped) return;
        stopped = true;
        clearTimeout(timer);
        clearActive();
      };

      const start = () => {
        if (stopped) return;
        clearTimeout(timer);
        setActive();
        timer = setTimeout(advance, interval);
      };

      const pause = () => {
        clearTimeout(timer);
      };

      // Stop on user interaction (tap or click)
      const stopHandler = () => stop();
      cycle.addEventListener('pointerdown', stopHandler, { once: true, passive: true });
      cycle.addEventListener('touchstart', stopHandler, { once: true, passive: true });

      // Run only when section is visible
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              start();
            } else {
              pause();
            }
          });
        },
        { threshold: 0.3 }
      );
      observer.observe(cycle);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
